import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './component/APP/App.jsx';
import './main.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
